﻿export class FileUploadStarted {
    static eventName() { return 'FileUploadStarted' }
    eventName = FileUploadStarted.eventName;
}